import { measureLatency } from '../../gctl-measure';
import {
  UserCapabilitiesFields,
  UserCapabilities,
} from '../../models/components/schemas/user-capabilities/UserCapabilities';
import { Select, NetworkError, deepCamelCase, intoSnakeCase } from '../../fetchers/_helpers';

/**
 * This file was automatically generated by @gctl/openapi-fetchers
 * Do not modify this file, any changes will be destroyed when
 * the command is rerun.
 */

export type GetMeCapabilitiesFields = readonly UserCapabilitiesFields[];

/** Options for GET /me/capabilities */
export type GetMeCapabilitiesOptions<Paths extends readonly string[]> = Omit<
  RequestInit,
  'method' | 'body'
> & {
  baseUrl?: string;

  /** Available fields on the response type, application/vnd.vimeo.capabilities+json */
  select: Paths;
};

/** Result type for GET /me/capabilities */
export type GetMeCapabilitiesResult<Paths extends readonly string[]> = Select<
  UserCapabilities,
  Paths
>;

/**
 * Get user capabilities
 * This method returns the set of capabilities belonging to the specified user.
 */
export async function getMeCapabilities<Paths extends GetMeCapabilitiesFields>({
  baseUrl,
  select,
  ...options
}: GetMeCapabilitiesOptions<Paths>): Promise<GetMeCapabilitiesResult<Paths>> {
  return measureLatency('getMeCapabilities', 'GET', async () => {
    let res = await fetch(
      `${baseUrl}/me/capabilities?fields=${select.map(intoSnakeCase).join(',')}`,
      {
        ...options,
        method: 'GET',
      },
    );

    if (!res.ok) {
      throw new NetworkError('A network error occurred', res.status, res);
    }

    if (res.status === 204) {
      return null as unknown as GetMeCapabilitiesResult<Paths>;
    }

    if (!res.headers.get('content-type')?.match(/^application\/(.+)?json$/)) {
      throw new Error('Expected JSON response');
    }

    let json = await res.json();
    return deepCamelCase(json);
  });
}
